/** Виды проблем поставки (`issues[].kind` из ozon_fin_supply_diag, порт build_dataset.py). */
import type { SupplyIssue } from "@/api/ozonAnalytics";

export const ISSUE_KIND: Record<string, string> = {
  mix: "Смешанные ГМ",
  swap: "Пересорт",
  short: "Недовоз",
  over: "Излишек",
  defect: "Брак",
  shelf: "Сроки годности",
  summary_diff: "Расхождение в акте",
  shortage_charge: "Недовоз по ГМ",
  surplus_charge: "Излишки по ГМ",
  defect_charge: "Брак (списание)",
  proc: "Обработка без разбивки",
  xd_expensive: "Дорогой кросс-док",
  nocontent: "ГМ без состава",
  cancelled: "Отменена",
  unident: "Неопознанный товар",
  nometa: "Нет данных",
};

/** Подпись вида; неизвестный код показываем как есть — видно, что контракт расширился. */
export function issueLabel(kind: string): string {
  return ISSUE_KIND[kind] ?? kind;
}

/** Серьёзность → классы чипа: error — ошибка, avoidable — можно было избежать, прочее — инфо. */
export function sevClass(sev: string): string {
  if (sev === "error") return "bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-300";
  if (sev === "avoidable") return "bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300";
  return "bg-sky-100 text-sky-800 dark:bg-sky-950 dark:text-sky-300";
}

const SEV_RANK: Record<string, number> = { error: 0, avoidable: 1, risk: 2, cost: 3, unknown: 4, info: 5 };

/** Уникальные виды проблем (первая встреча вида — его серьёзность), серьёзные первыми. */
export function issueKinds(issues: SupplyIssue[]): { kind: string; sev: string; count: number }[] {
  const m = new Map<string, { kind: string; sev: string; count: number }>();
  for (const i of issues) {
    const cur = m.get(i.kind);
    if (cur) cur.count += 1;
    else m.set(i.kind, { kind: i.kind, sev: i.sev, count: 1 });
  }
  return [...m.values()].sort(
    (a, b) => (SEV_RANK[a.sev] ?? 9) - (SEV_RANK[b.sev] ?? 9) || a.kind.localeCompare(b.kind),
  );
}
